import { render, staticRenderFns } from "./AllDistroInventories.vue?vue&type=template&id=6c5b7003&scoped=true"
import script from "./AllDistroInventories.vue?vue&type=script&lang=js"
export * from "./AllDistroInventories.vue?vue&type=script&lang=js"
import style0 from "./AllDistroInventories.vue?vue&type=style&index=0&id=6c5b7003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5b7003",
  null
  
)

export default component.exports